/** The FamilyChores "family check" mark (master: assets/brand/familychores-icon.svg). Decorative unless `title` is set. */
export function Logo({ size = 32, title }: { size?: number; title?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} className="shrink-0">
      {title ? <title>{title}</title> : null}
      <rect width="100" height="100" rx="22" fill="#2A9D8F" />
      <circle cx="29" cy="35" r="9" fill="#FFFFFF" />
      <circle cx="71" cy="35" r="9" fill="#FFFFFF" />
      <circle cx="50" cy="42" r="7" fill="#F2C14E" />
      <path d="M27 62 L43 76 L74 51" fill="none" stroke="#FFFFFF" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
